module.exports = __webpack_public_path__ + "static/img/Windhager.a475f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Windhager.jpg
// module id = B4yh
// module chunks = 0